import http from '@root/utils/axios/admin';

let state = {
    GamesList: [],
    GetMainGamesList: [],
    PopularGamesList: [],
    GamesIGDBNewReleasesList: [],
    GamesVideosMostAnticipatedEverList: [],
    Game: {
        data: {},
        error: {}
    },
    GamesIGDBList: [],
    GameIGDB: {
        data: {},
        error: {}
    },
    GenresIGDBList: [],
    GamePerformance: {}
}

let actions = {

    fetchGamesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/games', { params: filter }).then((response) => {
                commit('setGamesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchGetMainGamesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/get-last-games', { params: filter }).then((response) => {
                commit('setGetMainGamesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchPopularGamesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/games/popular', { params: filter }).then((response) => {
                commit('setPopularGamesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchGame({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/games/' + id).then((response) => {
                commit('setGame', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchGamesIGDBList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/games', { params: filter }).then((response) => {
                commit('setGamesIGDBList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchGameIGDB({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/games/' + id).then((response) => {
                commit('setGameIGDB', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchGenresIGDBList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/genres', { params: filter }).then((response) => {
                commit('setGenresIGDBList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    checkGamePerformance({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('subscriber/check-game-performance', data).then((response) => {
                commit('setGamePerformance', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },




    fetchGamesIGDBNewReleasesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/games/new-releases', { params: filter }).then((response) => {
                commit('setGamesIGDBNewReleasesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchGamesVideosMostAnticipatedEverList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/source/games/videos/most-anticipated/ever', { params: filter }).then((response) => {
                commit('setGamesVideosMostAnticipatedEverList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

}


let mutations = {
    setGamesIGDBNewReleasesList(state, data) {
        state.GamesIGDBNewReleasesList = data;
    },
    setGamesList(state, data) {
        state.GamesList = data;
    },
    setGetMainGamesList(state, data) {
        state.GetMainGamesList = data;
    },
    setPopularGamesList(state, data) {
        state.PopularGamesList = data;
    },
    setGame(state, data) {
        state.Game.data = data;
    },
    setGameIGDB(state, data) {
        state.GameIGDB.data = data;
    },
    setGamesIGDBList(state, data) {
        state.GamesIGDBList = data;
    },
    setGenresIGDBList(state, data) {
        state.GenresIGDBList = data;
    },
    setGamesVideosMostAnticipatedEverList(state, data) {
        state.GamesVideosMostAnticipatedEverList = data;
    },
    setGamePerformance(state, data) {
        state.GamePerformance = data;
    }
}

export default {
    state,
    actions,
    mutations
}